import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  StatusBar,
} from 'react-native';
import Icon from '../components/Icon';
import { useTheme } from '../context/ThemeContext';
import { vs, spacing, fontSize, iconSize } from '../utils/responsive';

const PrivacyScreen = ({ navigation }) => {
  const { colors, isDarkMode } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <StatusBar barStyle={isDarkMode ? "light-content" : "dark-content"} backgroundColor={colors.background} />

      {/* Header */}
      <View style={[styles.header, { backgroundColor: colors.headerBackground, borderBottomColor: colors.border }]}>
        <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
          <Icon name="arrow-back" size={iconSize.md} color={colors.primary} />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: colors.primary }]}>Privacy Policy</Text>
        <View style={styles.placeholder} />
      </View>

      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>1. Information We Collect</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We collect information you provide directly to us when you create an account, including your name, email address, phone number, and any other information you choose to provide.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>2. How We Use Your Information</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We use the information we collect to provide, maintain, and improve our services, to process your transactions, to send you technical notices and support messages, and to communicate with you about products, services, and events.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>3. Information Sharing</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We do not share your personal information with third parties except as described in this privacy policy. We may share information with service providers who perform services on our behalf.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>4. Data Security</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction. However, no security system is impenetrable.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>5. Trading Data</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            Your trading history, transaction data, and account balances are stored securely and used solely for providing trading services and generating reports for your account.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>6. Cookies and Tracking</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We may use cookies and similar tracking technologies to track activity on our application and hold certain information to improve and analyze our services.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>7. Your Rights</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            You have the right to access, update, or delete your personal information at any time. You can do this through your account settings or by contacting our support team.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>8. Children's Privacy</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            Our services are not directed to children under 18. We do not knowingly collect personal information from children under 18.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>9. Changes to Privacy Policy</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last Updated" date.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: colors.text }]}>10. Contact Us</Text>
          <Text style={[styles.sectionText, { color: colors.textSecondary }]}>
            If you have any questions about this Privacy Policy, please contact us through the Help & Support section in the app.
          </Text>
        </View>

        <View style={{ height: vs(40) }} />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: spacing.base,
    paddingTop: vs(8),
    paddingBottom: vs(16),
    borderBottomWidth: 1,
  },
  backButton: {
    padding: spacing.xs,
  },
  headerTitle: {
    fontSize: fontSize.xl,
    fontWeight: '700',
  },
  placeholder: {
    width: 32,
  },
  content: {
    flex: 1,
    paddingHorizontal: spacing.base,
  },
  section: {
    marginTop: vs(24),
  },
  sectionTitle: {
    fontSize: fontSize.lg,
    fontWeight: '600',
    marginBottom: vs(8),
  },
  sectionText: {
    fontSize: fontSize.base,
    lineHeight: 24,
  },
});

export default PrivacyScreen;
